export function add34() {
  setInterval(() => {
    const $ringpools = document.querySelectorAll('.wal-drp-phone')

    if ($ringpools.length !== 0) {
      $ringpools.forEach((drp) => {
        const ringpoolWithPrefix = '+34' + window.DFI.telefonoRingPoolActivo ?? '919498177'
        drp.setAttribute('href', `tel:${ringpoolWithPrefix}`)
      })
    }
  }, 300)
}
